var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileMondayServiceGray = function SvgMobileMondayServiceGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M4.255 3.727c-1.54.649-2.292 2.275-1.595 3.934.903 2.143 4.876 3.362 5.064 3.39.167.025.363-.071.363-.257 0-.185-.363-1.725-.363-1.834 0-.11.061-.207.167-.251.105-.044 4.712-1.997 6.24-2.64a2.98 2.98 0 0 0 1.595-3.933C15.07.576 13.33-.106 11.793.541c-1.535.647-5.997 2.54-7.538 3.188z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#676879",
    fillRule: "evenodd",
    d: "M14.93 15.456c1.543-.648 2.293-2.274 1.596-3.933-.903-2.144-4.876-3.354-5.064-3.38-.167-.026-.363.07-.363.255 0 .186.363 1.719.363 1.828a.27.27 0 0 1-.167.25c-.105.044-4.712 1.997-6.24 2.64A2.98 2.98 0 0 0 3.46 17.05c.657 1.562 2.396 2.241 3.933 1.595s5.997-2.54 7.538-3.189",
    clipRule: "evenodd"
  })));
};
export default SvgMobileMondayServiceGray;